/* eslint-disable react/jsx-props-no-spreading */
import { CellButton, CellButtonProps } from '@vkontakte/vkui';
import { FC } from 'react';
import styles from './styles.module.scss';

export const CustomCellButton: FC<CellButtonProps> = props => {
  const { children, className, ...otherProps } = props;
  return (
    <CellButton
      {...otherProps}
      className={`${styles.custom_button} ${className}`}
    >
      {children}
    </CellButton>
  );
};
